import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { environment } from 'src/environments/environment';
import { mergeMap } from 'rxjs/operators';

export type ApiProduct = {
  id: string;
  active: boolean;
  title: string;
  quickbooks_item_code: string;
  created_at: string;
  updated_at: string;
};

@Injectable({
  providedIn: 'root',
})
export class ApiProductsService {
  getAllApiProductsUrl = environment.serverUrl + '/api-products/get-all';

  constructor(
    private firebaseService: FirebaseService,
    private http: HttpClient
  ) {}

  getAllApiProducts() {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        return this.http.get<ApiProduct[]>(this.getAllApiProductsUrl, {
          headers: { Authorization: 'Bearer ' + token },
        });
      })
    );
  }
}
